import { createSeoOptimizedProductName, filterProductDiscounts } from '../libraries/Utils';
const hasIncludedPrice = (product) => product.foreignIds &&
    product.foreignIds.onlinePosRules &&
    product.foreignIds.onlinePosRules.cart &&
    product.foreignIds.onlinePosRules.cart.find((c) => c.inclPrice);
const sortProductsByComposite = (p1, p2) => {
    if (p1.isPartOfCompositeProduct === true) {
        return -1;
    }
    else if (p2.isPartOfCompositeProduct === true) {
        return 1;
    }
    return 0;
};
const extendProduct = (product, catalogData) => {
    if (product.discount) {
        product.discount = filterProductDiscounts(product, {
            channel: catalogData.channel,
            deliveryMethod: catalogData.deliveryMethod,
            customerType: catalogData.customerType,
        });
    }
    product.seoOptimizedName = createSeoOptimizedProductName(product.name);
    return product;
};
export { hasIncludedPrice, sortProductsByComposite, extendProduct };
